import { render, staticRenderFns } from "./FormFolio.vue?vue&type=template&id=2f11085a&"
import script from "./FormFolio.vue?vue&type=script&lang=js&"
export * from "./FormFolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports